<template>
  <el-dialog :visible="visible" v-on:close="$emit('update:visible', false)" center width="500px" title="Archive Event">
    <div class="text-center">
      <img class="inline" :src="require('../../assets/images/delete-impact-post.svg')" width="247px" height="207px"
        alt="Message Sent">
      <div class="text-sm opacity-80 mx-10 sm:mx-4 -mt-6">
        This event will no longer be visible by attendees. However, you can unarchive it to display it again
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="flex justify-between">
        <el-button size="medium" @click="$emit('update:visible', false)">Cancel</el-button>

        <el-button v-on:click="archiveEvent(); $emit('update:visible', false)" type="danger" size="medium">Archive Event
        </el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { EventsTickets } from "@/utils/api";

export default {
  name: "archive-event-modal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeEvent: null
  },
  methods: {
    archiveEvent() {
      const allowed = [
        'name', 'description', 'addressId', 'isVirtual', 'maxQuantity', 'address', 'externalUrl', 'video',
        'startDate', 'endDate', 'state', 'videoId', 'featuredImage', 'featuredImageId', 'timezone'
      ];
      const eventDetails = JSON.parse(JSON.stringify(this.activeEvent));

      if (eventDetails.video) {
        eventDetails.videoId = eventDetails.video['id']
      } else {
        eventDetails.videoId = null
      }
      delete eventDetails['video']

      if (eventDetails.featuredImage) {
        eventDetails.featuredImageId = eventDetails.featuredImage['id']
      } else {
        eventDetails.featuredImageId = null
      }
      delete eventDetails['featuredImage']

      const eventDetailsObj = Object.keys(eventDetails)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
          obj[key] = eventDetails[key];
          return obj;
        }, {});
      eventDetailsObj.state = 'archived';

      eventDetailsObj.maxQuantity= eventDetailsObj.maxQuantity === undefined ? null : eventDetailsObj.maxQuantity ;

      if (eventDetailsObj.isVirtual) {
        eventDetailsObj['addressId'] = null
      } else {
        eventDetailsObj['externalUrl'] = null
      }

      EventsTickets.updateEvent(
        this.activeEvent.id,
        eventDetailsObj,
        this.activeCharityId,
      ).then(() => {
        this.$message('Your event has been archived! This may take a minute to update on your event');
        this.$emit("archived")
      }).catch((err) => alert(err.message || 'An error has occurred, please try again.'));
    },
  },
  computed: {
    ...mapState({
      activeCharityId: state => state.auth.activeCharityId,
    }),
  }
}
</script>
